import React from "react";
import { useRecoilState } from "recoil";

import { StripePaystationState } from "../../../State";
import { Stripe } from "../../StripePaystation";
import { Modal } from "../../Modal";

export const StripePayStation = () => {
  const [paystation, setPaystationOpen] = useRecoilState(StripePaystationState);

  // trialCardSetup/trialReactivation are dropped on close: several openers
  // spread the previous atom value, and a stale flag would silently turn their
  // subscribe checkout into the wrong session type.
  const setModalOpen = (isModalOpen: boolean) =>
    setPaystationOpen({
      ...paystation,
      isModalOpen,
      ...(isModalOpen
        ? {}
        : { trialCardSetup: false, trialReactivation: false }),
    });

  const handleModalClose = () =>
    setPaystationOpen({
      ...paystation,
      isModalOpen: false,
      trialCardSetup: false,
      trialReactivation: false,
    });

  return (
    <Modal
      isModalOpen={paystation.isModalOpen}
      setModalOpen={setModalOpen}
      handleModalClose={handleModalClose}
      disableOutsideClose={false}
    >
      <Stripe />
    </Modal>
  );
};
